import React from "react";
//import { Redirect } from "react-router-dom";
import Joi from "joi-browser";
import Form from "./common/form";
import auth from "../services/authService";

//import firebase from "firebase/app";


class LoginForm extends Form {
  state = {
    data: { username: "", password: "" },
    errors: {}
  };

  schema = {
    username: Joi.string()
      .required()
      .label("Username"),
    password: Joi.string()
      .required()
      .label("Password")
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;

      await auth.login(data.username, data.password);

      const { state } = this.props.location;

      // if (
      //   data.username === "adib@salmustasharak.com" ||
      //   data.username === "mohannad@salmustasharak.com"
      // ) {

      // const userinfo = await firebase
      //   .auth()
      //   .signInWithEmailAndPassword(data.username, data.password);
      // localStorage.setItem("userId", userinfo.user.uid);
      //console.log("Hello");

      setTimeout(function () {
        window.location = state ? state.from.pathname : "/ddreams";
      }, 5000);
      // }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        console.log(JSON.stringify(ex));
        this.setState({ errors });
      }
    }
  };

  render() {
    // setTimeout(function() {
    //   if (auth.getCurrentUser()) return <Redirect to="/mobile" />;
    // }, 5000);

    return (
      <div>
        <h1>Login</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("username", "Username")}
          {this.renderInput("password", "Password", "password")}
          {this.renderButton("Login")}
        </form>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/loginForm.jsx